import { render, staticRenderFns } from "./AddCodewordsModal.vue?vue&type=template&id=1eafc260&scoped=true&"
import script from "./AddCodewordsModal.vue?vue&type=script&lang=js&"
export * from "./AddCodewordsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCodewordsModal.vue?vue&type=style&index=0&id=1eafc260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eafc260",
  null
  
)

export default component.exports